export const OBSERVER_OPTIONS = {
  threshold: 0.1,
  rootMargin: '0px'
};

export const DATA_ATTRIBUTE = 'data-toast-target';
